/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useState, useEffect } from 'react';
import { Grid, FormControlLabel, Checkbox, Switch, Button } from '@mui/material';
import rateRange from 'modules/common/constants/heatmap-config';
import Calender from '../calendar';
/**
 * Rate calendar view is defined here
 * @returns
 */
const RateCalendarView = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [heatMapToggle, setHeatMapToggle] = useState(false);
  //
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  //
  return (
    <Grid container direction="row" spacing={6}>
      <Grid
        item
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={4}
        ml={7}
      >
        <Grid item>
          <FormControlLabel
            control={
              <Switch
                checked={heatMapToggle}
                onChange={(event) => setHeatMapToggle(event.target.checked)}
              />
            }
            label="Heat map"
          />
          {heatMapToggle &&
            rateRange.map((element) => (
              <Button
                key={element.backgroundColor}
                variant="contained"
                disabled
                sx={{
                  marginRight: '3px',
                  '&:disabled': {
                    backgroundColor: element?.backgroundColor,
                    color: element?.textColor,
                  },
                }}
              >
                {element?.label}
              </Button>
            ))}
        </Grid>
        <FormControlLabel
          control={<Checkbox checked={isChecked} onChange={() => setIsChecked((prev) => !prev)} />}
          label="Show Events and Metrics"
        />
      </Grid>
      <Calender isChecked={isChecked} heatMap={heatMapToggle} handleChange={setIsChecked} />
    </Grid>
  );
};
//
export default RateCalendarView;
